import {useStepsContext} from "../../contexts/StepsContext";

/**
 * @returns {boolean}
 */
export function canGoBack() {
    const { getActiveStep } = useStepsContext();
    return ! getActiveStep().first;
}

/**
 * @returns {boolean}
 */
export function canProceedToNextStep() {
    const { getActiveStep } = useStepsContext();
    return !getActiveStep().last;
}

/**
 * @returns {boolean}
 */
export function canRegisterForMembership() {
    // TODO: Check rules that need to be applied for it to show "register for investin membership" button
    return false;
}

/**
 * @returns {boolean}
 */
export function canCheckoutOrAddToCart() {
    const { getActiveStep } = useStepsContext();
    // TODO: Validate form is filled in
    // TODO: Validate on last step
    // TODO: Validate anything else that was required previously
    return getActiveStep().last;
}

/**
 * @returns {boolean}
 */
export function canQuickRegister() {
    // TODO: Check if user has a membership
    // TODO: Check if course is included in membership
    // TODO: Check anything else that was previously done
    return false;
}
